/* MOUD — prix Kaching réorganisés :
   - cases 1 / 2 / 4 sachets : prix par tasse de la formule choisie (« 0,80 € / tasse ») ;
   - case « Abonnement flexible » : prix du pack choisi en abonnement + prix barré,
     et une pastille « Économisez N % » (réduction réelle, arrondie au supérieur) sous le titre ;
   - case « Achat unique » : prix du pack choisi sans abonnement.
   Kaching n'affiche que les prix de la formule sélectionnée : avec l'abonnement, le prix
   barré d'un pack = son prix en achat unique. On mémorise donc les deux prix par pack. */
(function () {
  function toNumber(text) {
    var n = parseFloat(String(text).replace(/[^\d,.]/g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }
  function euros(n) {
    var s = (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
    return s.replace(/,00$/, '') + ' €';
  }
  function text(el) {
    return el ? el.textContent.trim() : '';
  }

  function init(bundle) {
    var cache = {}; // index du pack → { sub: nombre, once: nombre }
    var pending = false;

    function packs() {
      return Array.prototype.filter.call(bundle.querySelectorAll('.kaching-bundles__bar'), function (bar) {
        return !bar.querySelector('.kaching-bundles__subscriptions__card');
      });
    }
    function formulas() {
      return bundle.querySelectorAll('.kaching-bundles__subscriptions__card');
    }
    function put(parent, cls, html) {
      if (!parent) return;
      var el = parent.querySelector(':scope > .' + cls);
      if (!el) {
        el = document.createElement('div');
        el.className = cls;
        parent.appendChild(el);
      }
      if (el.innerHTML !== html) el.innerHTML = html;
    }

    function render() {
      pending = false;
      var cards = formulas();
      if (cards.length < 2) return;
      var subSelected = cards[0].closest('.kaching-bundles__bar').classList.contains('kaching-bundles__bar--selected');

      var list = packs();
      var selectedIndex = -1;
      list.forEach(function (bar, i) {
        var price = toNumber(text(bar.querySelector('.kaching-bundles__bar-price')));
        var full = toNumber(text(bar.querySelector('.kaching-bundles__bar-full-price')));
        cache[i] = cache[i] || {};
        if (subSelected && price !== null) {
          cache[i].sub = price;
          if (full !== null) cache[i].once = full;
        } else if (!subSelected && price !== null) {
          cache[i].once = price;
        }
        if (bar.classList.contains('kaching-bundles__bar--selected')) selectedIndex = i;

        var cups = toNumber(text(bar.querySelector('.kaching-bundles__bar-subtitle')));
        var current = subSelected ? cache[i].sub : cache[i].once;
        if (cups && current) {
          put(bar.querySelector('.kaching-bundles__bar-pricing'), 'moud-kb-cup',
            '<span class="moud-kb-cup__value">' + euros(current / cups) + '</span><span class="moud-kb-cup__unit">/ tasse</span>');
        }
      });

      var sel = cache[selectedIndex] || {};
      if (sel.sub) {
        put(cards[0].querySelector('.kaching-bundles__bar-content'), 'moud-kb-price',
          '<span class="moud-kb-price__now">' + euros(sel.sub) + '</span>' +
          (sel.once && sel.once > sel.sub ? '<s class="moud-kb-price__was">' + euros(sel.once) + '</s>' : ''));
      }
      if (sel.sub && sel.once && sel.once > sel.sub) {
        put(cards[0].querySelector('.kaching-bundles__bar-content-left'), 'moud-kb-off',
          'Économisez ' + Math.ceil((1 - sel.sub / sel.once) * 100 - 1e-9) + '\u00a0%');
      }
      if (sel.once) {
        put(cards[1].querySelector('.kaching-bundles__bar-content'), 'moud-kb-price',
          '<span class="moud-kb-price__now">' + euros(sel.once) + '</span>');
      }
      bundle.classList.add('moud-kb-ready');
    }
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(render);
    }

    new MutationObserver(function (mutations) {
      // ignore nos propres insertions
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        var el = t.nodeType === 1 ? t : t.parentElement;
        if (!el || !el.closest('.moud-kb-cup, .moud-kb-price, .moud-kb-off')) { schedule(); return; }
      }
    }).observe(bundle, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    schedule();
  }

  function start() {
    document.querySelectorAll('kaching-bundle').forEach(function (bundle) {
      if (bundle.dataset.moudKbPrices || !bundle.querySelector('.kaching-bundles__subscriptions__card')) return;
      bundle.dataset.moudKbPrices = '1';
      init(bundle);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  setTimeout(start, 2500);
  setTimeout(start, 6000);
})();
